import { ActionIcon, Menu, Tooltip } from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons-react';
import * as React from 'react';

import s from './DocumentTreeAction.module.scss';

type TreeNodeOptionsProps = {
  /**
   * Элементы выпадающего меню.
   */
  items: React.ReactNode | React.ReactNode[];
  dropdownClassName?: string;
  /**
   * Текст для aria-label триггера меню.
   */
  triggerLabel?: string;
  disabled?: boolean;
  disabledTooltip?: string;
};

const TreeNodeOptions: React.FC<TreeNodeOptionsProps> = ({
  items,
  dropdownClassName,
  triggerLabel = 'Открыть меню',
  disabled = false,
  disabledTooltip,
}) => {
  const handleClick = React.useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  }, []);

  if (disabled) {
    return (
      <Tooltip label={disabledTooltip} disabled={!disabledTooltip} withArrow position="bottom-end">
        <span>
          <ActionIcon
            component="div"
            role="button"
            tabIndex={-1}
            variant="transparent"
            size="sm"
            className={s.root__disabled}
            onClick={handleClick}
          >
            <IconDotsVertical size={16} className={s.root__icon} />
          </ActionIcon>
        </span>
      </Tooltip>
    );
  }

  return (
    <Menu
      radius={16}
      classNames={{ dropdown: dropdownClassName }}
      position="bottom-end"
      withinPortal={true}
      shadow="md"
    >
      <Menu.Target>
        <ActionIcon
          component="div"
          role="button"
          tabIndex={0}
          aria-label={triggerLabel}
          variant="subtle"
          size="sm"
          onClick={handleClick}
        >
          <IconDotsVertical size={16} className={s.root__icon} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>{items}</Menu.Dropdown>
    </Menu>
  );
};

export default React.memo(TreeNodeOptions);
